module.exports = __webpack_public_path__ + "static/assets/header-beli.5736ca07.png";